import { render, staticRenderFns } from "./DataViewModal.vue?vue&type=template&id=8b3c4176&"
import script from "./DataViewModal.vue?vue&type=script&lang=js&"
export * from "./DataViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports